import React from "react";
import { Phone, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";
import { PRIMARY_PHONE } from "@/lib/site";

export const MobileCallBar = () => {
  return (
    <div
      data-testid="mobile-sticky-call-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur-xl"
    >
      <div className="grid grid-cols-2 gap-2 p-2">
        <a
          href={`tel:${PRIMARY_PHONE.tel}`}
          data-testid="mobile-bar-call-button"
          className="flex items-center justify-center gap-2 rounded-md bg-[var(--color-secondary)] py-3 text-sm font-bold text-white hover:bg-[var(--color-secondary-soft)] transition-colors"
        >
          <Phone className="h-4 w-4" />
          Call Now
        </a>
        <Link
          to="/contact"
          data-testid="mobile-bar-quote-button"
          className="flex items-center justify-center gap-2 rounded-md bg-[var(--color-primary)] py-3 text-sm font-bold text-white hover:bg-[var(--color-primary-soft)] transition-colors"
        >
          <MessageSquare className="h-4 w-4" />
          Free Quote
        </Link>
      </div>
    </div>
  );
};

export default MobileCallBar;
